import { request } from '@@/plugin-request';

export async function getOptions(params) {
  return request('/api/products/services', {
    method: 'GET',
    params,
  });
}
